/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

export const getUserPublicKeyPathParamsSchema = z.object({
  id: z.string(),
})

/**
 * @description Successfully fetched a user\'s public key
 */
export const getUserPublicKey200Schema = z.object({
  publicKey: z.string().describe("The user's RSA public key"),
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const getUserPublicKey401Schema = APIErrorSchema

/**
 * @description User not found
 */
export const getUserPublicKey404Schema = APIErrorSchema

export const getUserPublicKeyQueryResponseSchema = getUserPublicKey200Schema
